import styled from 'styled-components';
import { CHROME_INSET_PX } from './chrome.constants';

export const GridSlot = styled.div`
  position: absolute;
  right: ${CHROME_INSET_PX}px;
  bottom: ${CHROME_INSET_PX}px;
  z-index: 2;
  pointer-events: auto;
`;
